import Typography from '@mui/material/Typography';
import { CheckBoxGrid, PdfCheckBox } from '../../ui/styled';

const FormCheckboxPdf = ({ item }) => {
  const { checked, label } = item || {};
  return (
    <CheckBoxGrid>
      <PdfCheckBox checked={checked} defaultChecked size="small" />
      <Typography variant="h6">{label}</Typography>
    </CheckBoxGrid>
  );
};

export default FormCheckboxPdf;
